import { Container } from '@cleartrip/ct-design-components'
import React from 'react'

import { filterTypes } from '@/constants/Srp'
import { PossibleFilterTypes } from '@/types/srp'

import CheckboxItem from './checkboxItem'
import FilterCategory from './FilterCategory'
import VisaRejectionFilterLabel from './VisaRejectionFilterLabel'

const LEGACY_PADDING = { paddingTop: '12px', paddingBottom: '12px' }

type VisaRejectionFilterProps = {
  onFilterChange: (type: PossibleFilterTypes, filtersData: { enabled: boolean; checked: boolean }) => void
  selectedFilters: any
  clearFiltersCategoryWise?: (filterData: any, isRT: boolean, filterType: string) => void
  isRT?: boolean
  isRevamp?: boolean
}

const VerifiedUserIcon = () => (
  <svg fill='none' height='20' viewBox='0 0 20 20' width='20' xmlns='http://www.w3.org/2000/svg'>
    <mask
      height='20'
      id='mask0_8019_15702'
      maskUnits='userSpaceOnUse'
      style={{ maskType: 'alpha' }}
      width='20'
      x='0'
      y='0'
    >
      <rect fill='#D9D9D9' height='20' width='20' />
    </mask>
    <g mask='url(#mask0_8019_15702)'>
      <path
        d='M9.1248 12.9572L13.8331 8.24886L12.6456 7.06136L9.1248 10.5822L7.3748 8.83219L6.1873 10.0197L9.1248 12.9572ZM9.9998 18.3322C8.06924 17.8461 6.47549 16.7384 5.21855 15.0093C3.9616 13.2801 3.33313 11.36 3.33313 9.24886V4.16553L9.9998 1.66553L16.6665 4.16553V9.24886C16.6665 11.36 16.038 13.2801 14.781 15.0093C13.5241 16.7384 11.9304 17.8461 9.9998 18.3322Z'
        fill='#9E63E7'
      />
    </g>
  </svg>
)

const VisaRejectionFilter = ({
  onFilterChange,
  selectedFilters,
  clearFiltersCategoryWise,
  isRT = false,
  isRevamp = false,
}: VisaRejectionFilterProps) => {
  const { visaRejection: onwardVisaRejection } = selectedFilters?.onwardLeg || {}
  const { visaRejection: returnVisaRejection } = selectedFilters?.returnLeg || {}
  const visaRejectionEnabled = onwardVisaRejection || returnVisaRejection
  const currentVisaRejection = selectedFilters?.visaRejection || {
    enabled: visaRejectionEnabled || false,
    checked: false,
  }

  const handleCheckboxClick = () => {
    onFilterChange(filterTypes.VISA_REJECTION, {
      ...currentVisaRejection,
      checked: !currentVisaRejection.checked,
    })
  }

  const handleClear = () => {
    if (clearFiltersCategoryWise) {
      clearFiltersCategoryWise(selectedFilters, isRT, 'visaRejection')
    } else {
      onFilterChange(filterTypes.VISA_REJECTION, { enabled: false, checked: false })
    }
  }

  return (
    <FilterCategory
      count={Number(!!currentVisaRejection.checked)}
      isRevamp={isRevamp}
      title='Trip essentials'
      onClear={handleClear}
    >
      <Container className={isRevamp ? 'flex flex-column' : undefined} style={isRevamp ? undefined : LEGACY_PADDING}>
        <CheckboxItem
          checked={currentVisaRejection.checked}
          label={
            <Container className='flex flex-middle flex-gap-1'>
              <VisaRejectionFilterLabel className='c-pointer' />
              <VerifiedUserIcon />
            </Container>
          }
          rootClassName='w-100p'
          wrapperClassName='py-2 checkbox-hover-border'
          onClick={handleCheckboxClick}
        />
      </Container>
    </FilterCategory>
  )
}

export default VisaRejectionFilter
